<template>
  <div id="app">
    <app-header id="header"></app-header>
    <app-message v-if="notification!=null" id="message" :message="notification"></app-message>
    <div id="content">
      <router-view />
    </div>
    <app-footer id="footer"></app-footer>
  </div>
<!--  Note: Removed legacy #fill spacer to prevent excess scroll below footer -->
</template>

<script>

import Header from './Header.vue'
import Notification from './Notification.vue'
import Footer from './Footer.vue'
import * as cfg from './../config.js'

const configNotification = cfg.NOTIFICATION || null;

export default {
  name: 'App',
  data () {
    return {
      notification: configNotification
    }
  },

  components: {
    'app-header': Header,
    'app-message': Notification,
    'app-footer': Footer
  }
}
</script>

<style>
  /* App-level flex layout ensures footer sits at the bottom without extra scroll */
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #E7E7E7;
  }

  /* Main content grows to fill remaining space between header and footer */
  #content {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }

  #header {
    height: 70px;
  }

  /* Footer remains at the bottom of the viewport when content is short */
  #footer {
    margin-top: auto;
    width: 100%;
    flex-shrink: 0;
  }

  @media only screen and (max-width: 650px) {
    #footer {
      display: none;
    }
  }
</style>
